import { render, staticRenderFns } from "./VendorChange.vue?vue&type=template&id=3c11edee"
import script from "./VendorChange.vue?vue&type=script&lang=js"
export * from "./VendorChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports